import { imprimirCupomFechamento } from "@/utils/cupomFechamento";
import { imprimirCupomPreparo } from "@/utils/cupomPreparo";

import { itensParaPreparo } from "./lib";

const MODULO = "Comandas";
const nn = (c) => String(c?.numero || 0).padStart(2, "0");

/** A comanda no formato "mesa" que o cupom de fechamento lê. */
export function comandaComoMesa(c, pedido = c?.pedido) {
  return {
    numero: c.numero, nome: `Comanda ${nn(c)}`, comanda: null, cliente: c.cliente_nome || "",
    codigo: pedido?.codigo, total: c.total, opened_at: c.opened_at, closed_at: c.closed_at || null,
    items: pedido?.items || [],
  };
}

/** Cupom de fechamento (conferência da conta; com `log`, o do pagamento). */
export function imprimirFechamentoDaComanda(c, allProducts, log = null, pedido = c?.pedido) {
  return imprimirCupomFechamento(
    { ...comandaComoMesa(c, pedido), ...(log ? { pagamentos: { log } } : {}) },
    pedido ? [pedido] : [], null, log, allProducts,
  );
}

/** 2ª via do preparo: todos os itens vivos da comanda. */
export function imprimirPreparoDaComanda(c, allProducts) {
  const pedido = c?.pedido;
  return imprimirCupomPreparo({
    items: itensParaPreparo(pedido?.items, allProducts), codigo: pedido?.codigo,
    created_at: pedido?.created_at || c.opened_at, cliente_nome: c.cliente_nome || "—",
    comanda: nn(c), modulo: MODULO, _tituloItens: "— 2ª VIA —",
  });
}
